class Download {
  constructor(el, fields) {
    this.el = el;
    this.fields = fields;
    this.emailField = this.el.querySelector('[data-js-subscribe-email]');

    this.el.addEventListener(
      'submit',
      e => {
        e.preventDefault();
        this.handleSubmit();
      },
      true
    );
  }

  handleSubmit() {
    let args = {
      action: 'newsletter_subscribe'
    };

    Object.assign(args, this.getValues());

    jQuery.post(myAjax.ajaxurl, args, response => {
      if (response.success == false) {
        this.fail(response.message);
      } else {
        // Show success message
        this.success();
      }
    });
  }

  success() {
    this.handleTracking();
    this.removeMessage('validation_error');
    $('[data-js-download]').hide();
    $('#thankyou').show();
  }

  fail(status) {
    console.log('fail');
    if (status === 'Invalid email address') {
      this.emailField.setAttribute('aria-invalid', true);
    }

    if (!this.el.querySelector('.validation_error')) {
      this.addMessage(status, 'validation_error');
    }

    this.removeMessage('form-success');
  }

  addMessage(status, className) {
    const message = document.createElement('p');

    message.classList.add(className);
    message.innerHTML = 'An error occured. Please try again later.';

    this.el.append(message);
    this.el.reset();
  }

  removeMessage(className) {
    if (this.el.querySelector('.' + className)) {
      this.el.querySelector('.' + className).remove();
    }
  }

  getValues() {
    return Object.values(this.el).reduce((obj, field) => {
      obj[field.name] = field.value;
      return obj;
    }, {});
  }

  handleTracking() {
    dataLayer.push({ event: 'postDownloadNewsletterSubscription' });
  }
}

const downloadForm = document.querySelector('[data-js-download]');

if (downloadForm) {
  const download = new Download(downloadForm);
}
